import DualTextuary from "./Components/DualTextuary";

export default DualTextuary;
